import { isFunction, isNullOrUndefined } from 'shared/lib/utils';

import { getSvgMousePosition } from '@/lib/renderers/utils';

export function setUpDragableElements({
  svgEl,
  elementsById,
  elementBBoxesById,
  onElementDragStart,
  onElementDragEnd,
  onElementDrag,
}) {
  let elementIdBeingDragged;
  let clickOffset;

  const svgScreenCtm = svgEl.getScreenCTM();

  function startDrag(_el, elementId) {
    return (e) => {
      if (e.button !== 0) {
        return;
      }

      // NOTE: to prevent an interval selection from starting.
      e.stopPropagation();

      isFunction(onElementDragStart) && onElementDragStart();

      svgEl.classList.add('cursor-move');

      const elementBBox = elementBBoxesById.get(elementId);

      elementIdBeingDragged = elementId;
      clickOffset = getSvgMousePosition(svgScreenCtm, e);
      clickOffset.x -= elementBBox.x;
      clickOffset.y -= elementBBox.y;
    };
  }

  function endDrag(e) {
    if (e.button !== 0) {
      return;
    }

    if (isNullOrUndefined(elementIdBeingDragged)) {
      return;
    }

    svgEl.classList.remove('cursor-move');

    const elementBBox = elementBBoxesById.get(elementIdBeingDragged);
    const positionAtDragEng = [elementBBox.x, elementBBox.y];
    const elementId = elementIdBeingDragged;

    elementIdBeingDragged = null;

    isFunction(onElementDragEnd) &&
      onElementDragEnd(elementId, positionAtDragEng);
  }

  function drag(e) {
    if (e.button !== 0) {
      return;
    }

    if (isNullOrUndefined(elementIdBeingDragged)) {
      return;
    }

    const elementBBox = elementBBoxesById.get(elementIdBeingDragged);

    const mousePosition = getSvgMousePosition(svgScreenCtm, e);
    const [newX, newY] = [
      mousePosition.x - clickOffset.x,
      mousePosition.y - clickOffset.y,
    ];
    elementBBox.x = newX;
    elementBBox.y = newY;

    isFunction(onElementDrag) &&
      onElementDrag(elementIdBeingDragged, [newX, newY]);
  }

  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const _this = this;

  elementsById.forEach((g, elementId) => {
    g.addEventListener(
      'mousedown',
      startDrag.bind(_this)(g, elementId).bind(_this)
    );
  });

  svgEl.addEventListener('mouseup', endDrag.bind(this));
  svgEl.addEventListener('mousemove', drag.bind(this));
  svgEl.addEventListener('mouseleave', endDrag.bind(this));
}
